import * as React from 'react';

type Props = {
  val: number | bigint;
};
export const NumberCompactFormat = ({ val }: Props) => {
  return <>{Intl.NumberFormat('ja-JP', { notation: 'compact' }).format(val)}</>;
};
